import * as types from '../types.js';

export default {

	html: `
		<style>
			#sku-no-output-form #company_id  { width: 15rem; }
			#sku-no-output-form #warehouse_id { width: 15rem; }
			#sku-no-output-form #date_from,
			#sku-no-output-form #date_to     { width: 10rem; }
		</style>
		<form id="sku-no-output-form" class="form" autocomplete="off">
			<datalist id="snor-companies"></datalist>
			<datalist id="snor-warehouses"></datalist>
			<div class="title">SKUs sem Saída no Período</div>
			<p class="mts fss" style="color:var(--color-muted)">
				Lista lotes com quantidade <strong>disponível para separação</strong> de produtos
				que não tiveram baixa física de saída no período. Inclui validade e custo unitário da entrada.
			</p>
			<div class="mtm">
				<label>Empresa<sup>*</sup>
					<input id="company_id" type="text" list="snor-companies" required>
				</label>
			</div>
			<div class="mtm" style="display:flex;gap:1rem;flex-wrap:wrap">
				<label>De<sup>*</sup>
					<input id="date_from" type="date" required>
				</label>
				<label>Até<sup>*</sup>
					<input id="date_to" type="date" required>
				</label>
			</div>
			<div class="mtm">
				<label>Armazém (opcional)
					<input id="warehouse_id" type="text" list="snor-warehouses">
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class="bn_Escape button">Fechar</button>
					<button type="button" class="bn_Enter button">Consultar</button>
				</span>
			</div>
		</form>
	`,

	form: {
		selector: '#sku-no-output-form',
		init(formset) {
			formset.form.eraseValues();
			formset.loadList('#snor-companies',  'companies',  { labels: ['nick'] });
			formset.loadList('#snor-warehouses', 'warehouses', { labels: ['name'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#company_id'  }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#date_from'   }, types: [types.pubsub()] },
		{ properties: { selector: '#date_to'     }, types: [types.pubsub()] },
		{ properties: { selector: '#warehouse_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('warehouses')] },
	],

};
